export type AddDeviceNavigationState = { openAddDevice: true };

export const ADD_DEVICE_NAVIGATION_STATE: AddDeviceNavigationState = {
  openAddDevice: true,
};

export const isAddDeviceNavigationState = (
  state: unknown
): state is AddDeviceNavigationState =>
  state !== null &&
  typeof state === "object" &&
  "openAddDevice" in state &&
  state.openAddDevice === true;
